var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',_vm._b({attrs:{"value":_vm.textValue,"label":_vm.label,"required":_vm.required,"error-messages":_vm.errors || []},on:{"input":_vm.onEdit}},'v-text-field',_vm.customProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }